<!-- <div style="padding-top: 7%;">
  <div class="signin-content">
    <mat-card class="example-card">
      <div style="display: flex; flex-direction: column; align-items: center;">

        <div>
          <img src="../../assets/plimes_logo.png" class="plimes_logo" alt="plimes_logo">
        </div>

        <h2 style="margin-bottom: 30px;">セクションへの参加が完了しました</h2>

        <div class="top-bottom-spacer-2x"></div>
        <p>
          こちらからGOKURIへログインしましょう<br>
        </p>

        <div class="login">
          <button mat-raised-button color="primary" (click)=login()>ログイン</button>
        </div>
      </div>

    </mat-card>
  </div>
</div>
 -->





<meta charset="utf-8">
<title i18n="@@pages.joinSectionConfirmed.title.page">ログイン｜GOKURI</title>
<meta name="viewport" content="width=device-width,initial-scale=1,user-scalable=yes">

<link rel="shortcut icon" href="/favicon.ico">
<link rel="apple-touch-icon" size="150x150" href="/apple-touch-icon.png">

<div class="l-wrap">
  <div class="login">
    <div class="login__panel">
      <div class="login__body">
        <div class="login__logo"><img ngSrc="../../assets/bannerlogo.png" alt="GOKURI CLOUD SERVICE" width="560" height="120" /></div>
        <div class="login__intro">
          <p class="login__heading" i18n="@@pages.joinSectionConfirmed.message.loginPrompt">こちらから<br class="is-sp">ログインしましょう</p>
          <div class="login__section-name" i18n="@@pages.joinSectionConfirmed.message.joinCompleted">セクションへの参加が完了しました</div>
        </div>
        <!-- /login__intro -->
        <div class="login_entry">
          <div class="btn_login">
            <button (click)=login() i18n="@@pages.joinSectionConfirmed.button.login">ログイン</button>
          </div>
          <!-- /btn_login -->
        </div>
        <!-- /login_entry -->
      </div>
      <!-- /login__body -->
    </div>
    <!-- /login__panel -->
  </div>
  <!-- /login -->
</div>
<!-- /l-wrap -->
